<template>
  <TeamReport report-mode="overview" />
</template>

<script>
import TeamReport from './team.vue';

export default {
  name: 'ManagerOverview',
  components: {
    TeamReport,
  },
};
</script>
